import React from 'react';
import PropTypes from 'prop-types';

const Highlight = ({ children: text, range: highlightRange }) => {
  if (highlightRange) {
    const ranges = highlightRange
      .split(',')
      .map((range) => range.split('-').map((bound) => Number.parseInt(bound, 10)));

    return ranges.reduce(
      (acc, [start, end]) => {
        const last = acc.slice(-1)[0];
        const addressIndex = text.length - last.length;
        const startIndex = start - addressIndex;
        const endIndex = end - addressIndex;

        return [
          ...acc.slice(0, acc.length - 1),
          last.slice(0, startIndex),
          <b key={start}>{last.slice(startIndex, endIndex)}</b>,
          last.slice(endIndex, last.length)
        ];
      },
      [text]
    );
  }
  return text;
};

Highlight.propTypes = {
  children: PropTypes.string.isRequired,
  range: PropTypes.string
};

Highlight.defaultProps = {
  range: null
};

export default Highlight;
